module.exports = __webpack_public_path__ + "static/media/logo-front.72ed24d0.svg";